import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import _ from 'lodash';
import chartFilterSlice from '../../../../redux/slices/chartFilterSlice';
import { autoEscapeCharactersForCharts } from '../Chart';
import { COLORS, FONT_FAMILIES, FONT_SIZES } from '../../../../styles/constants';
import { CHARTS_TRANSLATION_STRINGS } from '../chartConstant';

class ColumnChart extends Component {
	componentDidMount() {
		this.initChart();
	}

	componentDidUpdate(prevProps) {
		// Handle refreshing the chart when the dataset changes
		if (
			//!_.isEqual(prevProps.filtersAppliedState, this.props.filtersAppliedState) ||
			!_.isEqual(prevProps.productTableData, this.props.productTableData) ||
			!_.isEqual(prevProps.chartDefinition, this.props.chartDefinition)
		) {
			if (this.chart) {
				this.chart.dispose();
			}

			this.initChart();
		}
	}

	componentWillUnmount() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	initChart() {
		const { productTableData, chartDefinition, changeFilterValue } = this.props;
		const chartData = this.createChartData();
		const COLOR1 = COLORS.PRIMARY;
		const COLOR2 = COLORS.SECONDARY2;

		// Themes begin
		am4core.options.commercialLicense = true;
		am4core.addLicense('CH2281-6107-0011-9579');
		// Themes end

		// Create chart instance
		var chart = am4core.create('chartdiv', am4charts.XYChart);
		chart.strokeWidth = 0.5;
		chart.stroke = am4core.color('black');
		chart.fontSize = FONT_SIZES.BODY2;
		chart.fontWeight = 50;
		chart.fontFamily = FONT_FAMILIES;
		chart.paddingTop = 10;
		chart.paddingBottom = 30;
		chart.marginBottom = 60;
		chart.zoomOutButton.background.fill = am4core.color('gray');
		chart.zoomOutButton.background.states.getKey('hover').properties.fill = am4core.color(COLORS.BACKGROUND_GREY_DARK);
		chart.zoomOutButton.align = 'right';
		chart.zoomOutButton.valign = 'bottom';
		chart.zoomOutButton.marginBottom = 5;

		var title = chart.titles.create();
		//title.text = chartDefinition.gfHeading;
		title.fontSize = 20;

		// Create axes
		var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.title.text = autoEscapeCharactersForCharts(chartDefinition.xaxeLabel);
		categoryAxis.dataFields.category = 'x';
		categoryAxis.renderer.grid.template.location = 0;
		categoryAxis.renderer.minGridDistance = 30;
		categoryAxis.renderer.grid.template.disabled = false;
		categoryAxis.title.fontWeight = 10;
		categoryAxis.strokeWidth = 0.2;
		categoryAxis.marginTop = 10;
		categoryAxis.cursorTooltipEnabled = chartData.length > 8;

		var label = categoryAxis.renderer.labels.template;
		label.disabled = chartData.length > 8;
		label.wrap = true;
		label.truncate = xLableTruncate();
		categoryAxis.events.on('sizechanged', function (ev) {
			var axis = ev.target;
			var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
			axis.renderer.labels.template.maxWidth = cellWidth;
		});
		label.tooltipText = '{x}';

		function xLableTruncate() {
			let truncate = false;
			chartData.forEach(d => {
				if (d.x.length > 16) {
					truncate = true;
				}
			});
			return truncate && chartData.length > 4;
		}

		var valueAxis1 = chart.yAxes.push(new am4charts.ValueAxis());
		valueAxis1.title.text = autoEscapeCharactersForCharts(chartDefinition.y1AxeLabel);
		valueAxis1.title.fontWeight = 10;
		valueAxis1.title.fill = am4core.color(COLOR2);
		valueAxis1.min = 0;
		valueAxis1.renderer.grid.template.disabled = false;
		valueAxis1.strokeWidth = 0.2;
		valueAxis1.renderer.line.strokeOpacity = 1;
		valueAxis1.renderer.line.strokeWidth = 2;
		valueAxis1.renderer.line.stroke = am4core.color(COLOR2);
		valueAxis1.renderer.labels.template.fill = am4core.color(COLOR2);

		var valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
		valueAxis2.renderer.opposite = true;
		valueAxis2.title.text = autoEscapeCharactersForCharts(chartDefinition.y2AxeLabel);
		valueAxis2.title.rotation = -90;
		valueAxis2.title.fontWeight = 10;
		valueAxis2.title.fill = am4core.color(COLOR1);
		valueAxis2.renderer.grid.template.disabled = true;
		valueAxis2.strokeWidth = 0.2;
		valueAxis2.renderer.line.strokeOpacity = 1;
		valueAxis2.renderer.line.strokeWidth = 2;
		valueAxis2.renderer.line.stroke = am4core.color(COLOR1);
		valueAxis2.renderer.labels.template.fill = am4core.color(COLOR1);

		// Create series
		var series2 = chart.series.push(new am4charts.ColumnSeries());
		series2.dataFields.valueY = 'y1Max';
		series2.dataFields.openValueY = 'y1Min';
		series2.dataFields.categoryX = 'x';
		series2.yAxis = valueAxis1;
		series2.clustered = false;
		series2.columns.template.width = am4core.percent(80);
		series2.tooltipText =
			autoEscapeCharactersForCharts(chartDefinition.y1Label) +
			': [bold]{openValueY}[/] - [bold]{valueY}[/] ' +
			autoEscapeCharactersForCharts(chartDefinition.y1Unit);
		series2.columns.template.fill = am4core.color(COLOR2);
		series2.columns.template.stroke = am4core.color('black');
		series2.strokeWidth = 0.5;
		series2.columns.template.column.cornerRadiusTopLeft = 0;
		series2.columns.template.column.cornerRadiusTopRight = 0;
		series2.columns.template.column.cornerRadiusBottomLeft = 0;
		series2.columns.template.column.cornerRadiusBottomRight = 0;
		series2.name = 'Price Range';

		var series = chart.series.push(new am4charts.ColumnSeries());
		series.dataFields.valueY = 'y2Max';
		series.dataFields.openValueY = 'y2Min';
		series.dataFields.categoryX = 'x';
		series.yAxis = valueAxis2;
		series.clustered = false;
		series.columns.template.width = am4core.percent(35);
		series.tooltipText =
			autoEscapeCharactersForCharts(chartDefinition.y2Label) +
			': [bold]{openValueY}[/] - [bold]{valueY}[/] ' +
			autoEscapeCharactersForCharts(chartDefinition.y2Unit);
		series.tooltip.pointerOrientation = 'horizontal';
		series.columns.template.fill = am4core.color(COLOR1);
		series.columns.template.stroke = am4core.color('black');
		series.strokeWidth = 0.5;
		series.columns.template.column.cornerRadiusTopLeft = 0;
		series.columns.template.column.cornerRadiusTopRight = 0;
		series.columns.template.column.cornerRadiusBottomLeft = 0;
		series.columns.template.column.cornerRadiusBottomRight = 0;
		series.name = 'Power Range';

		series.columns.template.column.events.on('hit', function (event) {
			changeFilterValue({
				cid: chartDefinition.filterByCid,
				value: event.target.dataItem._dataContext.x
			});
		});

		series2.columns.template.column.events.on('hit', function (event) {
			changeFilterValue({
				cid: chartDefinition.filterByCid,
				value: event.target.dataItem._dataContext.x
			});
		});

		var hoverStateWidth = series.columns.template.states.create('hover');
		hoverStateWidth.properties.strokeWidth = 1.5;
		var hoverState = series.columns.template.column.states.create('hover');
		hoverState.properties.cornerRadiusTopLeft = 20;
		hoverState.properties.cornerRadiusTopRight = 20;
		hoverState.properties.cornerRadiusBottomLeft = 20;
		hoverState.properties.cornerRadiusBottomRight = 20;

		var hoverStateWidth2 = series2.columns.template.states.create('hover');
		hoverStateWidth2.properties.strokeWidth = 1.5;
		var hoverState2 = series2.columns.template.column.states.create('hover');
		hoverState2.properties.cornerRadiusTopLeft = 20;
		hoverState2.properties.cornerRadiusTopRight = 20;
		hoverState2.properties.cornerRadiusBottomLeft = 20;
		hoverState2.properties.cornerRadiusBottomRight = 20;

		series.cursorOverStyle = am4core.MouseCursorStyle.pointer;
		series2.cursorOverStyle = am4core.MouseCursorStyle.pointer;

		chart.cursor = new am4charts.XYCursor();
		chart.cursor.lineX.disabled = true;
		chart.cursor.lineY.disabled = true;

		let labelMessage = chart.createChild(am4core.Label);
		labelMessage.text = '';
		labelMessage.fontSize = 14;
		labelMessage.fill = COLORS.TEXT_PRIMARY;
		labelMessage.strokeWidth = 0;
		labelMessage.isMeasured = false;
		labelMessage.x = am4core.percent(55);
		labelMessage.y = am4core.percent(30);
		labelMessage.horizontalCenter = 'middle';
		labelMessage.wrap = true;

		if (chartData.length === 0 && productTableData.length === 0) {
			labelMessage.text = CHARTS_TRANSLATION_STRINGS.noProducts;
		} else if (chartData.length === 0 && productTableData.length !== 0) {
			labelMessage.text = CHARTS_TRANSLATION_STRINGS.notAllData;
		}

		categoryAxis.events.on('sizechanged', function (ev) {
			var cell = ev.target;
			labelMessage.maxWidth = cell._prevLength - 100;
		});

		chart.data = chartData;
	}

	render() {
		return (
			<div
				id="chartdiv"
				style={{
					width: '100%',
					height: '300px',
					fontFamily: FONT_FAMILIES
				}}
			/>
		);
	}

	createChartData() {
		const { productTableData, chartDefinition } = this.props;
		const chartData = [];
		let xValues = [];

		productTableData.forEach(ptd => {
			xValues.push(ptd[chartDefinition.xcid]);
		});
		let xValueRangeUnique = [...new Set(xValues)].filter(item => item);

		xValueRangeUnique.forEach(xU => {
			let y1Values = [];
			let y2Values = [];

			productTableData.forEach(part => {
				if (
					part[chartDefinition.xcid] &&
					part[chartDefinition.xcid] === xU &&
					part[chartDefinition.y1Cid] &&
					part[chartDefinition.y2Cid]
				) {
					y1Values.push(Number(part[chartDefinition.y1Cid]));
					y2Values.push(Number(part[chartDefinition.y2Cid]));
				}
			});

			y1Values = y1Values.filter(item => item);
			y2Values = y2Values.filter(item => item);
			if (y1Values.length !== 0 && y2Values.length !== 0) {
				chartData.push({
					x: xU,
					y1Min: chartDefinition.y1MinMaxRange ? Math.min(...y1Values) : 0,
					y1Max: Math.max(...y1Values),
					y2Min: chartDefinition.y2MinMaxRange ? Math.min(...y2Values) : 0,
					y2Max: Math.max(...y2Values)
				});
			}
		});

		return chartData.filter(item => item).sort((a, b) => a.y1Max - b.y1Max);
	}
}

const mapDispatchToProps = dispatch => ({
	changeFilterValue: filterValues => dispatch(chartFilterSlice.actions.updateFiltrationParameters(filterValues))
});

export default connect(null, mapDispatchToProps)(ColumnChart);
